import React from 'react';

export class Focuspoint extends React.Component {

  constructor(props) {
    super(props);
    this.focusRef = React.createRef();
  }

  componentDidMount() {
      const node = this.focusRef.current;
      window.$(node).focusPoint({
        reCalcOnWindowResize: true,
      });

      setTimeout(()=>{
        window.$(node).focusPoint('adjustFocus');
      }, 100);
  }

  componentDidUpdate() {
    window.$(this.focusRef.current).focusPoint('adjustFocus');
  }

  componentWillUnmount() {
    window.$(this.focusRef.current).focusPoint('windowOff');
  }

  getImgSrc() {
    var hParam = '&h=';
    if (this.props.src && !this.props.src.includes('?')) {
      hParam = '?h=';
    }
    return this.props.src + hParam + this.props.imageH;
  }

  render() {
    return (<div ref={this.focusRef} className="focuspoint"
      data-focus-x={this.props.focusX}
      data-focus-y={this.props.focusY}
      data-image-w={this.props.imageW}
      data-image-h={this.props.imageH}>
      <img src={this.getImgSrc()} alt="" />
    </div>)
  }
}